import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";

/**
 * @title Basic select
 */
@Component({
  selector: ' app-st-select',
  templateUrl: 'st-select.component.html',
  styleUrls: ['st-select.component.scss'],
  standalone: false
})
export class StSelectComponent {

  @Input()
  defaultOption = 'Select';

  @Input()
  idVal: string = ''

  @Input()
  label: string = '';

  @Input()
  idKey: string = '';

  @Input()
  displayKey: string = '';

  @Input()
  valueKey: string = '';

  @Input()
  inputArray: any[] = [];

  @Input()
  inputVal: string = '';

  @Output()
  onClick = new EventEmitter<Event>();

  @Output()
  onchange = new EventEmitter<Event>();

  constructor() {

  }
}
